import React, { ReactNode } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";
import { Site } from "@/services/types";

interface SiteDescriptionCardProps {
  site: Site;
  getSiteDescription: (site: Site) => ReactNode;
}

const SiteDescriptionCard: React.FC<SiteDescriptionCardProps> = ({ site, getSiteDescription }) => {
  return (
    <Card className="border-gray-200 shadow-md">
      <div className="bg-fabre-lightgreen p-6">
        <h2 className="text-2xl font-bold text-fabre-green">À propos de {site.name}</h2>
      </div>
      <CardContent className="p-6">
        <div className="prose max-w-none">
          {getSiteDescription(site)}
          
          <h3 className="text-xl font-semibold mb-2 text-fabre-darkgreen">Pourquoi nous choisir ?</h3>
          <ul className="list-disc pl-5 mb-4">
            <li>Une équipe professionnelle et expérimentée</li>
            <li>Des solutions adaptées à vos besoins spécifiques</li>
            <li>Un engagement fort pour l'environnement</li>
            <li>Des tarifs compétitifs et transparents</li>
            <li>Un service clientèle à votre écoute</li>
          </ul>
          
          {site.websiteUrl && (
            <div className="mt-6 flex justify-center">
              <Button asChild className="bg-fabre-green hover:bg-fabre-darkgreen">
                <a href={site.websiteUrl} target="_blank" rel="noopener noreferrer" className="flex items-center">
                  Visiter le site officiel <ExternalLink className="ml-2 h-4 w-4" />
                </a>
              </Button>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default SiteDescriptionCard;
